module.exports = __webpack_public_path__ + "static/img/per18.955258e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/per18.jpg
// module id = jGZk
// module chunks = 41